export default "__VITE_ASSET__d7457d0d__"